enum CallCenterCallReason {
    CallReasonAppointmentBooking = 1,
    CallReasonRebookAppointment,
    CallReasonCancelAppointment,
    CallReasonAppointmentConfirmation,
    CallReasonAppointmentQuestions,
    CallReasonReferralUpdate,
    CallReasonResults,
    CallReasonRx,
    CallReasonPortal,
    CallReasonMiscellaneous
}

export { CallCenterCallReason };
